import axios, { AxiosInstance } from "axios";
import Config from "./../config/index";

const apiClient: AxiosInstance = axios.create({
  baseURL: Config.baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});

export default apiClient;
